import { render, staticRenderFns } from "./settings-organization-fonts-edit-dialog.vue?vue&type=template&id=52a3c81a&scoped=true&"
import script from "./settings-organization-fonts-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./settings-organization-fonts-edit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a3c81a",
  null
  
)

export default component.exports